import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { VendorBO } from './vendor.model';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }


  saveupdateVendor(saveList: VendorBO): Observable<VendorBO> {

    let url = "api/Vendor/SaveVendor";
    return this.http.post<VendorBO>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  deleteVendor(paramsData: URLSearchParams): Observable<number> {
    let url = "api/Vendor/DeleteVendor?"
    return this.http.delete<any>(url + paramsData).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }



  getLov(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getExportCsv(): Observable<any> {
    let url = "api/Vendor/GetVendorExcel?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )

  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


}

